import { Button } from '../components/ui/button';
import { useI18n } from './I18nContext';

/** Toggles between RU and EN locales */
export function LanguageSwitcher() {
  const { locale, setLocale } = useI18n();

  const handleToggle = () => {
    setLocale(locale === 'ru' ? 'en' : 'ru');
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleToggle}
      aria-label="Switch language"
      data-testid="language-switcher"
    >
      {locale === 'ru' ? 'EN' : 'RU'}
    </Button>
  );
}
